import { io } from "socket.io-client";
import { TEST_URL, isLocal, LOCAL_URL } from "../config/misc";

const URL = isLocal ? LOCAL_URL : TEST_URL;

export const socket = io(URL, {
  autoConnect: true,
  reconnection: true, // Enable reconnection
  reconnectionAttempts: Infinity, // Attempt to reconnect indefinitely
  reconnectionDelay: 1000, // Initial delay (in milliseconds) before attempting the first reconnection
  reconnectionDelayMax: 5000,
  reconnect: true,
  // transports: ["websocket"],
});

// Added error event listener
socket.on("error", (error) => {
  console.error("Socket connection error:", error);
});
